import {Card} from 'primereact/card';
import {ConfirmDialog} from 'primereact/confirmdialog';
import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import PdfDownloadSpinner from '../components/spinner/PdfDownloadSpinner';
import BlockUi from '../components/waitPanel/BlockUi';
import BaseContainer from './BaseContainer';
import { BreadCrumb } from 'primereact/breadcrumb';
import { t } from 'i18next';
//import { withTranslation } from 'react-i18next';

class BaseDetailsContainer extends BaseContainer {
    constructor(props, service) {
        super(props);
        this.service = service;
        this.onUpload = this.onUpload.bind(this);
        this.updateElement = this.updateElement.bind(this);
        this.createOrUpdate = this.createOrUpdate.bind(this);
        this.getAddSucces = this.getAddSucces.bind(this);
        this.getUpdateSucces = this.getUpdateSucces.bind(this);
        this.renderBackLink = this.renderBackLink.bind(this);
        this.getBackLabel = this.getBackLabel.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.renderView = this.renderView.bind(this);
        this.handleFileCountExceeded = this.handleFileCountExceeded.bind(this);
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.showRemoveConfirmation = this.showRemoveConfirmation.bind(this);
        this.hideRemoveConfirmation = this.hideRemoveConfirmation.bind(this);
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this);
        this.backLinkRendered = true;
        if (service !== undefined && service !== null) {
            this.service.setUiMethods(this.blockUi, this.unblockUi, this.props.updateApp);
        }
        this.navigationContext.addOrUpdateParam("elementId", props.elementId);
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.initBeforeSetElement();
        this.setElement();
    }

    showRemoveConfirmation() {
        this.setState({showConfirmRemoveDialog: true});
    }

    hideRemoveConfirmation() {
        this.setState({showConfirmRemoveDialog: false});
    }

    onRemoveAction(type, costam, target) {
        if (target.value) {
            this.blockUi();
            this.service
                .remove(this.state.element)
                .then(() => {
                    this.persistMessage('success', '', this.getRemoveSucces());
                    window.location.href = this.props.backUrl;
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                    this.hideRemoveConfirmation();
                });
        } else {
            this.hideRemoveConfirmation();
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId} = this.state;
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, viewMode)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handleGetDetailsError(err) {
        this.showErrorMessage('Błąd podczas pobrania szczegółów');
        if (this.props. Url) {
            window.location.href = this.navigationContext.addNavigationContextToUrl(this.props.backUrl);
        } else {
            this.setState({loading: false}, () => this.unblockUi());
        }
    }

    updateElement(data) {
        if (this._isMounted) {
            this.setState(
                {
                    element: data,
                },
                () => this.initAfterSetElement()
            );
        }
    }

    initAfterSetElement() {
        if (this.props.handleRenderHeader) {
            this.props.handleRenderHeader(this.renderTopPanel);
        }
        this.unblockUi();
    }

    initBeforeSetElement() {}

    onUpload(event, varName) {
        const {element} = this.state;
        const varValue = JSON.parse(event.xhr.response);
        if (this._isMounted) {
            const modifiedList = element[varName].concat(varValue);
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    [varName]: modifiedList,
                },
            }));
        }
    }

    handleFileCountExceeded(max) {
        this.showInfoMessage(`Maksymanla ilość załączanych plików wynosi: ${max}!`, 10000);
        this.scrollToTop();
    }

    getAddSucces() {
        return 'Element został utworzony';
    }

    getUpdateSucces() {
        return 'Element został zaktualizowany';
    }

    getRemoveSucces() {
        return 'Element został usunięty';
    }

    handleValidForm(redirectAfterSuccess = true) {
        console.log('handleValidForm', this.state.element);
        this.createOrUpdate(this.state.element, redirectAfterSuccess);
    }

    afterAddSuccess(response, redirect) {
        const {backUrl, editUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', this.getAddSucces(response));
        if (redirect) {
            this.navigationContext.addOrUpdateParam("elementId", response.id);
            window.location.href = this.navigationContext.addNavigationContextToUrl(backUrl);
        } else {
            window.location.href = this.navigationContext.addNavigationContextToUrl(`${editUrl}/${response.id}`);
        }
        
    }

    afterUpdateSuccess(response, redirect) {
        const {backUrl} = this.props;        
        const msg = this.getUpdateSucces(response);
        if (redirect) {
            this.blockUi();
            this.persistMessage('success', '', msg);
            window.location.href = this.navigationContext.addNavigationContextToUrl(backUrl);
        } else {
            this.unblockUi();
            this.showSuccessMessage(msg);
        }
        
    }

    createOrUpdate(element = this.state.element, redirectAfterSuccess = true) {
        if (redirectAfterSuccess) {
            this.scrollToTop();
        }
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.afterAddSuccess(response, redirectAfterSuccess);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message, 10000);
                        this.unblockUi();
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.afterUpdateSuccess(response, redirectAfterSuccess);
                    })
                    .catch((err) => {
                        if (!redirectAfterSuccess) {
                            this.scrollToTop();
                        }
                        this.showErrorMessage(err.message, 10000);
                        this.unblockUi();
                    });
            }
        }
    }

    getBackLabel() {
        return 'Wróć';
    }

    handleGoBack(e) {
        e.preventDefault();
        let backUrl = this.navigationContext.generaterBackUrl();
        backUrl = backUrl ? backUrl : this.navigationContext.addNavigationContextToUrl(this.props.backUrl)
        window.location.href = backUrl;
    }

    renderBackLink() {
        return (
            <ActionLink
                id='back-button'
                rendered={this.backLinkRendered}
                label={this.getBackLabel()}
                className='p-link float-right'
                handleClick={this.handleGoBack.bind(this)}
                variant='green'
                iconName='mdi-arrow-left'
                iconSide='left'
                iconSize='xs'
                iconColor='green'
            />
        );
    }

    isPdfButtonRendered() {
        return true;
    }

    renderPdfDownloadButton() {
        return (
            <ActionButton
                label={this.getPdfDownloadLabel()}
                className='pdf-download-button'
                handleClick={this.handleDownloadPdf.bind(this)}
                disabled={this.state.downloadingPdf}
            />
        );
    }

    prepareEditButton(rendered, label) {
        const {editUrl} = this.props;
        const {element} = this.state;
        return {
            label: label !== undefined ? label : 'Edytuj',
            type: 'BUTTON',
            variant: '',
            className: 'float-right',
            href: `${editUrl}/${element.id}`,
            rendered: rendered,
            iconName: 'mdi-pencil',
            iconSide: 'left',
            iconSize: 'm',
        };
    }

    handleCancelButtonClick(e) {
        e.preventDefault();
        const {backUrl, cancelUrl, viewMode} = this.props;
        const {element} = this.state;
        let url;
        if (viewMode === 'NEW') {
            url = backUrl;
        } else {
            url = `${cancelUrl}/${element.id}`;
        }
        url = this.navigationContext.addNavigationContextToUrl(url);
        window.location.href = url;
    }


    prepareFooterItems() {
        
        const { viewMode } = this.props;
        
        switch (viewMode) {
            case 'EDIT':
            case 'NEW':
                return [
                    {id:"cancel-footer-btn", label: t('global.cancelButton'), className: 'cancel-button white', onClick: e => this.handleCancelButtonClick(e), id: 'cancel-button'},
                    {id:"apply-footer-btn", label: t('global.applyButton'), className: 'float-right', onClick: e => this.handleFormSubmit(e, false), id: 'apply-button'},
                    {id:"save-footer-btn", label: t('global.saveButton'), className: 'float-right', onClick: this.handleFormSubmit, id: 'save-button'},
                ];            
            case 'VIEW':
            default:
                return [];
        }
    }

    renderDetails() {
        return null;
    }

    render() {
        //return this.renderView();
        return (
            <div className='container-fluid'>
                {this.renderView()}
            </div>
        );
    }

    renderView() {
        // const items = [{ label: 'Projekty' }, { label: 'Projekt' },];
        // const home = { icon: 'pi pi-home', url: 'https://primereact.org' }
        return (
            <DivContainer colClass='details-main'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    //rendered={!this.props.embedded}
                >
                    <ConfirmDialog
                        visible={this.state.confirmDialog?.visible}
                        onHide={() => this.setConfirmDialogVisibility(false)}
                        message={this.translate(`${this.state.confirmDialog?.message}`)}
                        header={this.translate(`${this.state.confirmDialog?.header}`)}
                        icon={`pi ${this.state.confirmDialog?.header}`}
                        accept={() => this.setConfirmDialogVisibility(false)}
                        rejectClassName='display-none'
                        acceptClassName='confirm-dialog-accept'
                    />
                    <div className='row' /*style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}*/>
                        <div className='col-6 backlink'>{this.renderBackLink()}</div>
                        {/* <BreadCrumb model={items} home={home} /> */}
                        {this.isPdfButtonRendered() ? (
                            <div className='col-6' style={{textAlign: 'right'}}>
                                {this.renderPdfDownloadButton()}
                            </div>
                        ) : null}
                    </div>
                    <DivContainer colClass='col-12 details-main-link-container'>
                        <DivContainer colClass='row'>
                            <DivContainer colClass='col-12'>{this.state.loading ? null : this.renderCard()}</DivContainer>
                        </DivContainer>
                    </DivContainer>
                    {this.state.downloadingPdf && <PdfDownloadSpinner />}
                </BlockUi>
            </DivContainer>
        );
    }

    renderCard() {
        return (            
            <Card className='details-card' footer={this.renderFooter()} header={this.renderHeader()}>
                <form onSubmit={this.handleFormSubmit} noValidate autoComplete='off'>
                {this.renderDetails()}
                </form>
                
            </Card>            
        );
    }

    renderViewWithoutCard() {
        return <DivContainer colClass=''>{this.state.loading ? null : this.renderDetails()}</DivContainer>;
    }
}

BaseDetailsContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
};

BaseDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default BaseDetailsContainer;
